import { render } from "./Communities.view.vue?vue&type=template&id=3feeca72"
import script from "./Communities.view.vue?vue&type=script&lang=js"
export * from "./Communities.view.vue?vue&type=script&lang=js"

import "./Communities.view.vue?vue&type=style&index=0&id=3feeca72&lang=scss"
import "./Communities.view.vue?vue&type=style&index=1&id=3feeca72&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__